<template>
  <div>
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%"
      show-summary
      :summary-method="getSummaries"
    >
      <el-table-column type="index" width="70" label="序号" align="left" />
      <el-table-column
        prop="telegraphicTransferNum"
        label="电汇底单编号"
        align="left"
      />
      <el-table-column
        prop="contractSum"
        label="订单金额"
        align="right"
        header-align="left"
      />
      <el-table-column
        prop="assignAmount"
        label="已分配金额"
        align="right"
        header-align="left"
      />
      <el-table-column
        prop="usedScale"
        label="分配金额比例"
        align="right"
        header-align="left"
      />
      <el-table-column prop="createBy" label="分配人" align="left" />
      <el-table-column prop="createTime" label="分配日期" align="left" />
      <!-- 同步ERP状态 -->
      <el-table-column label="同步ERP状态" align="left" width="120">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.syncSuccessFlag === false"
            type="text"
            @click="showErrorDetail(scope.row)"
          >
            失败
          </el-button>
          <span v-else>
            {{ scope.row.syncSuccessFlag === true ? '成功' : '待抛转' }}
          </span>
        </template>
      </el-table-column>
      <!--已抛到erp的合同，不允许撤销已分配的款项-->
      <el-table-column label="操作" align="left">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.buttonState === null && $route.query.distributeFlag && !$store.state.user.asSale"
            type="text"
            size="small"
            @click="cancelAllocation(scope.row)"
          >
            撤销分配
          </el-button>
          <el-button
            v-if="scope.row.buttonState === '可查看'"
            type="text"
            size="small"
            @click="showDetail(scope.row)"
          >
            查看
          </el-button>
          <span v-if="scope.row.buttonState !== null && scope.row.buttonState !== '可查看'">
            {{ scope.row.buttonState }}
          </span>
        </template>
      </el-table-column>
    </el-table>
    <div class="title">退款明细</div>
    <el-table
      v-loading="loading"
      :data="refundDetail"
      border
      style="width: 100%"
      show-summary
      :summary-method="getRefundDetailSummaries"
    >
      <el-table-column type="index" width="70" label="序号" align="left" />
      <el-table-column
        prop="telegraphicTransferNum"
        label="电汇底单编号"
        align="left"
      />
      <el-table-column
        prop="contractSum"
        label="订单金额"
        align="right"
        header-align="left"
      />
      <el-table-column
        prop="assignAmount"
        label="退款金额"
        align="right"
        header-align="left"
      />
      <el-table-column
        prop="usedScale"
        label="退款比例"
        align="right"
        header-align="left"
      />

      <el-table-column label="罚息金额" align="right" header-align="left" />

      <el-table-column prop="createBy" label="退款人" align="left" />
      <el-table-column prop="createTime" label="退款日期" align="left" />
    </el-table>
    <!-- 撤销原因 -->
    <el-dialog
      v-if="causeRevocationVisible"
      title="撤销原因"
      :visible.sync="causeRevocationVisible"
      width="800px"
      @close="close"
    >
      <el-input v-model="causeRevocation" type="textarea" maxlength="100" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="cancel">取消申请</el-button>
        <el-button type="primary" :loading="submitLoading" @click="onSubmit">提交申请</el-button>
      </span>
    </el-dialog>
    <!-- 查看 -->
    <el-dialog
      v-if="examineVisible"
      title="合同基本信息"
      :visible.sync="examineVisible"
      width="800px"
    >
      <examine :id="approvalNumID" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="examineVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 抛单异常详情 -->
    <el-dialog
      title="分配记录同步ERP状态查看"
      :visible.sync="errorDialogVisible"
      width="500px"
    >
      <div class="error-detail">
        <div class="error-item">
          <div class="error-value error-reason">{{ currentErrorInfo.syncFailReason }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="errorDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="es6">
import { selectAssignDetailByContractId, canclePayMoney, agSelectAssignDetailByContractId, undoDistributionAgree } from '@/API';
import { MathAdd, numDiv } from '@/libs/util';
import examine from './examine.vue';
export default {
  components: {
    examine
  },
  props: {
    contractId: {
      type: [String, Number],
      required: true
    },
    contractStatus: {
      type: [String, Number],
      required: true
    },
    contractType: {
      type: String,
      default: ''
    },
    isCanclePayMoney: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      tableData: [],
      loading: false,
      refundDetail: [],
      causeRevocation: '', // 撤销原因
      causeRevocationVisible: false,
      examineVisible: false,
      approvalNumID: 0,
      postData: {},
      submitLoading: false,
      errorDialogVisible: false,
      currentErrorInfo: {}
    };
  },

  computed: {
    allAssignAmount () {
      let cont = 0;
      this.tableData.forEach((item) => {
        cont = MathAdd(cont, item.assignAmount);
      });
      return cont.toFixed(2);
    }
  },

  mounted () {
    this.initData();
  },

  methods: {
    initData () {
      this.loading = true;
      let params = { oldContractNum: this.$route.params.contractNum };
      Promise.all([selectAssignDetailByContractId(this.contractId), agSelectAssignDetailByContractId(params)])
        .finally(() => (this.loading = false))
        .then(res => {
          if (res[0].data.status === '200') {
            this.tableData = res[0].data.data;
          }
          if (res[1].data.status === '200') {
            this.refundDetail = res[1].data.data;
          }
        });
    },

    // 退款明细合计行
    getRefundDetailSummaries (param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
        }
        if (column.label === '退款金额') {
          sums[index] = this.refundDetail.reduce((pre, cur) => MathAdd(cur.assignAmount, pre), 0);
        }
      });
      return sums;
    },

    getSummaries (param) {
      // let allowsum = ['数量', '订单金额', '实际结算金额'];
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '订单金额' && this.tableData.length) {
          sums[index] = this.tableData[0].contractSum;
          return;
        }
        if (column.label === '已分配金额') {
          sums[index] = this.allAssignAmount;
          return;
        }
        if (column.label === '分配金额比例' && this.tableData.length) {
          let pre = (numDiv(this.allAssignAmount * 100, this.tableData[0].contractSum)).toFixed(6);
          sums[index] = `${pre}%`;
        }
      });
      return sums;
    },
    canclePayMoney (row) {
      this.loading = true;

      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        canclePayMoney(row.contractAssignId).then((res) => {
          this.loading = false;
          if (res.status === 200) {
            this.$message({
              type: 'success',
              message: '成功撤销!'
            });
            this.initData();
          }
        }).catch(() => {
          this.loading = false;
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消撤销操作！'
        });
        this.loading = false;
      });
    },
    cancelAllocation (row) {
      this.causeRevocationVisible = true;
      this.postData.ids = [row.contractAssignId];
    },
    showDetail (val) {
      this.approvalNumID = val.contractAssignId;
      this.examineVisible = true;
    },
    onSubmit () {
      if (!this.causeRevocation) {
        this.$message.warning('撤销原因不能为空');
        return;
      }
      this.postData.type = 1;
      let type = this.$route.query.type ? this.$route.query.type : 1;
      this.postData.type = this.contractType && this.contractType.includes('服务') ? 1 : type;
      this.postData.reason = this.causeRevocation;
      this.submitLoading = true;
      undoDistributionAgree(this.postData).then((res) => {
        this.submitLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.$message({
            type: 'success',
            message: '成功撤销!'
          });

          this.initData();
          this.close();
        }
      }).catch(() => {
        this.submitLoading = false;
      });
    },
    cancel () {
      this.causeRevocationVisible = false;
      this.causeRevocation = '';
    },
    close () {
      this.cancel();
    },
    // 显示错误详情
    showErrorDetail (row) {
      this.currentErrorInfo = row;
      this.errorDialogVisible = true;
    }
  }

};
</script>

<style scoped>
.title {
  padding: 10px 0;
}
.status-normal {
  color: #606266;
}
.status-failed {
  color: #409eff;
  cursor: pointer;
  text-decoration: underline;
}
.status-failed:hover {
  opacity: 0.8;
}
.status-clickable {
  cursor: pointer;
}
.error-detail {
  padding: 10px 0;
}
.error-item {
  margin-bottom: 16px;
  line-height: 1.6;
}
.error-label {
  font-weight: 500;
  color: #606266;
  min-width: 80px;
  display: inline-block;
}
.error-value {
  color: #303133;
  word-break: break-all;
}
.error-reason {
  white-space: pre-wrap;
}
</style>
